import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/login_bg.jpg'
import _imports_1 from '../../../assets/images/logo.png'


const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "login-form-Code" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ActivationDialog = _resolveComponent("ActivationDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("img", {
      src: _imports_0,
      alt: "",
      style: {"width":"100%"},
      class: "image"
    }, null, -1)),
    _createVNode(_component_el_form, {
      ref: "loginFormRef",
      model: _ctx.loginForm,
      rules: _ctx.loginRules,
      class: "login-form",
      autocomplete: "on",
      "label-position": "left"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[8] || (_cache[8] = _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: "",
              style: {"width":"100%"}
            })
          ], -1)),
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.t("login.title")), 1)
        ]),
        _createVNode(_component_el_form_item, {
          prop: "username",
          required: ""
        }, {
          default: _withCtx(() => [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "svg-container" }, [
              _createElementVNode("i", { class: "iconfont icon-yonghu" })
            ], -1)),
            _createVNode(_component_el_input, {
              ref: "userNameRef",
              modelValue: _ctx.loginForm.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginForm.username) = $event)),
              placeholder: _ctx.t('login.username'),
              type: "text",
              tabindex: "1",
              clearable: "",
              autocomplete: "on"
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          prop: "password",
          required: ""
        }, {
          default: _withCtx(() => [
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "svg-container" }, [
              _createElementVNode("i", { class: "iconfont icon-mima" })
            ], -1)),
            _createVNode(_component_el_input, {
              ref: "passwordRef",
              modelValue: _ctx.loginForm.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginForm.password) = $event)),
              placeholder: _ctx.t('login.password'),
              type: "password",
              tabindex: "2",
              clearable: "",
              autocomplete: "on"
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_form_item, {
            prop: "verifyCode",
            required: ""
          }, {
            default: _withCtx(() => [
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "svg-container" }, [
                _createElementVNode("i", { class: "iconfont icon-yanzhengma" })
              ], -1)),
              _createVNode(_component_el_input, {
                ref: "verifiCodeRef",
                modelValue: _ctx.loginForm.verifyCode,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loginForm.verifyCode) = $event)),
                placeholder: _ctx.t('login.verifyCode'),
                tabindex: "2",
                clearable: "",
                autocomplete: "off",
                onKeyup: _withKeys(_ctx.handleLogin, ["enter"])
              }, null, 8, ["modelValue", "placeholder", "onKeyup"])
            ]),
            _: 1
          }),
          _createElementVNode("img", {
            src: _ctx.loginForm.verifiCodeImg,
            alt: "",
            class: "verifi-code-img",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getVerifiCode && _ctx.getVerifiCode(...args)))
          }, null, 8, _hoisted_5)
        ]),
        _createVNode(_component_el_checkbox, {
          modelValue: _ctx.loginForm.rememberMe,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.loginForm.rememberMe) = $event)),
          label: "自动登录",
          style: {}
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"width":"100%"},
          onClick: _withModifiers(_ctx.handleLogin, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("login.logIn")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createElementVNode("p", {
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openActivationDialog && _ctx.openActivationDialog(...args))),
          style: {"text-align":"center","color":"#fff","margin-top":"15px"},
          class: "cursor"
        }, "新用户登陆/忘记密码")
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_ActivationDialog, {
      visible: _ctx.activationDialogVisible,
      "onUpdate:visible": _cache[6] || (_cache[6] = (val) => _ctx.activationDialogVisible = val),
      onClose: _cache[7] || (_cache[7] = () => _ctx.activationDialogVisible = false)
    }, null, 8, ["visible"])
  ]))
}